import {styled, TextField} from '@mui/material';

const FieldsContainer = styled('div')`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;

	&:nth-child(3) {
		${({theme}) => theme.breakpoints.down('sm')} {
			grid-template-columns: 1fr;
		}
	}
`;

const StyledTextField = styled(TextField)`
	& input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	& input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	& input[type='number'] {
		appearance: textfield;
		-moz-appearance: textfield;
	}
`;

export {FieldsContainer, StyledTextField};
